import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "scale(.625)"
},
/*#__PURE__*/
React.createElement("circle", {
  stroke: "currentColor",
  strokeWidth: 2,
  fill: "none",
  cx: 16,
  cy: 16,
  r: 15
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M11.9643555,12.7773438 L14.1445312,12.7773438 C14.1816408,12.2021456 14.3826479,11.7444678 14.7475586,11.4042969 C15.1124693,11.0641259 15.5917939,10.894043 16.1855469,10.894043 C16.7731149,10.894043 17.2447085,11.0548487 17.6003418,11.3764648 C17.9559751,11.698081 18.1337891,12.1031877 18.1337891,12.5917969 C18.1337891,13.0494815 18.0209158,13.4298487 17.795166,13.7329102 C17.5694162,14.0359716 17.1689482,14.3606754 16.59375,14.7070312 C15.9567025,15.0843118 15.4974786,15.5002419 15.2160645,15.954834 C14.9346503,16.4094261 14.8155922,16.9830695 14.8588867,17.6757812 L14.8681641,18.3251953 L17.0205078,18.3251953 L17.0205078,17.7871094 C17.0205078,17.3232399 17.1287424,16.9428726 17.3452148,16.6459961 C17.5616873,16.3491196 17.9729787,16.0244158 18.5791016,15.671875 C19.2099641,15.2945945 19.6954736,14.8508326 20.0356445,14.3405762 C20.3758155,13.8303197 20.5458984,13.2195674 20.5458984,12.5083008 C20.5458984,11.4816029 20.1562539,10.6404655 19.3769531,9.98486328 C18.5976524,9.32926104 17.5740623,9.00146484 16.3061523,9.00146484 C14.9269137,9.00146484 13.8677609,9.35863901 13.1286621,10.072998 C12.3895634,10.7873571 12.001465,11.6887966 11.9643555,12.7773438 Z M16.0556641,22.7319336 C16.5195336,22.7319336 16.8906236,22.6005059 17.1689453,22.3376465 C17.447267,22.0747871 17.5864258,21.7207054 17.5864258,21.2753906 C17.5864258,20.8300759 17.447267,20.4744479 17.1689453,20.2084961 C16.8906236,19.9425442 16.5195336,19.8095703 16.0556641,19.8095703 C15.5856096,19.8095703 15.209881,19.9425442 14.9284668,20.2084961 C14.6470526,20.4744479 14.5063477,20.8300759 14.5063477,21.2753906 C14.5063477,21.7207054 14.6470526,22.0747871 14.9284668,22.3376465 C15.209881,22.6005059 15.5856096,22.7319336 16.0556641,22.7319336 Z",
  stroke: "none",
  fill: "currentColor",
  fillRule: "evenodd"
}));

var SvgUnknownUser = function SvgUnknownUser(props) {
  return _ref;
};

export default SvgUnknownUser;